<template>
  <bita-modal
    id="category-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام فارسی"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
            />
            <bita-input
              type="text"
              name="slug"
              label="نام انگلیسی"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.slug"
            />
            <bita-treeselect
              name="category_id"
              ref="categoryTreeselect"
              label="گروه"
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="getCategories"
              data-text-field="name"
              data-value-field="id"
              v-model="form.parent_id"
            />
            <bita-uploader
              name="uploader"
              label="تصویر"
              rules="size:50"
              ref="uploader"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.icon"
              :icon-url="form.icon_url"
              :deletable="true"
            />
            <bita-texteditor
              type="text"
              name="content"
              ref="descriptions"
              label="توضیحات"
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.description"
            />
          </div>
          <bita-formgroup title="سئو" class="row" style="margin-top:30px">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.title"
            />
            <bita-textarea
              type="text"
              name="title"
              label="توضیحات"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.description_seo"
            />
            <!-- <bita-input
              type="text"
              name="canonical"
              label="کنونیکال"
              rules=""
              :validation-container-class="largeColWidth"
              input-class="form-control"
              v-model="form.canonical"
            /> -->
            <bita-typeahead
              type="text"
              name="name"
              label="کلمه های کلیدی"
              :validation-container-class="largeColWidth"
              input-class="form-control"
              :data-source="matches"
              v-model="tags"
              @on-search="(e) => loadDataSource(e)"
            />
          </bita-formgroup>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!form.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
import { tagApi } from "@/api/apiManagement";
export default {
  props: {
    title: String,
    isLoading: Boolean,
    categories: Array,
    category: Object,
  },
  computed: {
    getCategories() {
      if (this.form.id)
        return collect(this.categories)
          .where("id", "!=", this.form.id)
          .all();
      return this.categories;
    },
  },
  data() {
    return {
      colWidth: "col-lg-4",
      largeColWidth: "col-lg-12",
      form: {},
      tags: [],
      imageData: "",
      matches: [],
    };
  },
  watch: {
    category(category) {
      this.form = category;
      this.tags = category.tags;
    },
  },
  methods: {
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", {
            ...this.form,
            tags: this.tags?this.tags.join(","):[],
          });
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", {
            ...this.form,
            tags: this.tags ? this.tags.join(",") : [],
          });
        }
      });
    },
    loadDataSource(tag) {
      tagApi.findTags({ tag: tag }).then((res) => {
        this.matches = collect(res.data.entity)
          .pluck("name.fa")
          .toArray();
      });
    },
    reset() {
      this.form.description = ''
      this.form = {};
      this.tags = [];
      this.$refs.form.reset();
      // this.$refs.descriptions.reset();
      this.$refs.uploader.reset();
      this.$refs.categoryTreeselect.emptyKendo();
      console.log('reset called');
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
